import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./TitleBar.css";

export default function TitleBar() {
    let navigate = useNavigate();
    const routeChange = () => {
        let path = '/';
        navigate(path);
    }

    return (
        <div className="title-bar-container">
            <div className="pole-container" />
            <div className="sign-container">

                <h1>美 術 委 託</h1>
                <h2>Commissions</h2>

                <div className="sign-rectangle">
                    <IconButton onClick={routeChange}>
                        <svg className="arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 42" fill="none">
                            <path d="M18.9014 0L36.0853 1.80457e-07L17.1839 20.8948L36.1909 41.9062L19.0069 41.9062L0 20.8948L18.9014 0Z" fill="#F9F0E8" />
                            <path d="M10.4948 15.2031L68.3254 15.2031V27.1348L10.4948 27.1348L10.4948 15.2031Z" fill="#F9F0E8" />
                        </svg>
                    </IconButton>
                    <div className="square"></div>
                    <div className="arrow"></div>
                </div>

                <div className="bottom-container">
                    <div className="return-text-container">
                        <h3>戻る</h3>
                        <h4>Back to home</h4>
                    </div>
                    <h2>アートコミッション</h2>
                    <div className="return-text-container"></div>
                </div>

            </div>
        </div>
    );
}